import { Elements } from '@stripe/react-stripe-js';
import type { Stripe } from '@stripe/stripe-js';
import { SplitElements, type SplitElementsProps } from './SplitElements';

interface PaymentMethodFormProps extends SplitElementsProps {
  stripe: Stripe | null;
}

export const PaymentMethodForm = ({
  stripe,
  submitBtnText,
  handleClose,
  handleCreateSuccess,
}: PaymentMethodFormProps) => {
  return (
    <Elements stripe={stripe}>
      <SplitElements
        submitBtnText={submitBtnText}
        handleClose={handleClose}
        handleCreateSuccess={handleCreateSuccess}
      />
    </Elements>
  );
};
